import * as React from "react";
import type { SVGProps } from "react";
const SvgIconAiSparkles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.32 5.97c-.42 0-.8.26-.97.65l-1.07 2.6c-.2.48-.58.86-1.06 1.06l-2.6 1.07c-.39.16-.65.55-.65.97 0 .43.26.81.65.97l2.6 1.08q.74.31 1.06 1.05l1.07 2.6c.16.4.55.65.97.65.43 0 .81-.25.97-.64l1.08-2.61c.2-.48.57-.86 1.05-1.05l2.6-1.08c.4-.16.65-.54.65-.97s-.25-.8-.64-.97l-2.61-1.07c-.48-.2-.86-.58-1.05-1.06l-1.08-2.6c-.16-.39-.54-.65-.97-.65m0 2.04.73 1.76c.34.83 1 1.49 1.83 1.83l1.76.72-1.76.73c-.83.34-1.5 1-1.83 1.83l-.73 1.76-.72-1.76c-.34-.83-1-1.5-1.83-1.83L8 12.32l1.76-.72c.65-.27 1.07-.85 1.44-1.45q.14-.04.23-.15.1-.1.16-.23z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.36 1.33c-.37 0-.7.22-.85.56L4.06 3c-.2.48-.58.86-1.06 1.06l-1.1.45c-.35.14-.57.48-.57.85 0 .36.22.7.56.84L3 6.66c.48.2.86.57 1.06 1.05l.45 1.11c.14.34.48.57.85.57.36 0 .7-.23.84-.57l.46-1.1c.2-.49.57-.87 1.05-1.06l1.11-.46c.34-.14.57-.48.57-.84 0-.37-.23-.7-.57-.85l-1.1-.45c-.49-.2-.87-.58-1.06-1.06L6.2 1.9c-.14-.35-.48-.57-.84-.57m0 2.23c.34.81.98 1.46 1.8 1.8-.82.34-1.46.98-1.8 1.8-.34-.82-.99-1.46-1.8-1.8.81-.34 1.46-.99 1.8-1.8"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconAiSparkles;
